import { render } from "./Footer.vue?vue&type=template&id=603ce7e4"
import script from "../../src/assets/js/pages/nav&tabs.js?vue&type=script&lang=js&external"
export * from "../../src/assets/js/pages/nav&tabs.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__